// extracted by mini-css-extract-plugin
export default {"hero":"panel_hero__1HYkI","panelBox":"panel_panelBox__dZ1IK","midleBox":"panel_midleBox__NLQPl","carousel":"panel_carousel__Mspqp","openGaPanel":"panel_openGaPanel__jgfFV"};